// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__fV6jD","clinicsSelect":"TableHeading_clinicsSelect__1aTnk"};